var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

import { action, autorun, extendObservable, reaction, runInAction, when } from 'mobx';
import Navigation from '../model/Navigation';
import { EventTypes } from '../events';
import processEvent from './processEvent';

var Scheduler = function () {
  function Scheduler(store, middleware) {
    var _this = this;

    _classCallCheck(this, Scheduler);

    this.dispatch = action(function (evt) {
      if (evt) {
        evt = _this.middleware.fold(evt, _this.store);

        if (evt) {
          _this.event = evt;
        }
      }
    });
    var initialNavigation = new Navigation({
      type: 'POP',
      sequence: -1,
      // this makes the first actual navigation sequence 0
      to: null
    });
    extendObservable(this, {
      currentNavigation: initialNavigation,
      event: {
        type: EventTypes.EMPTY,
        navigation: initialNavigation
      }
    });
    this.disposer = null;
    this.store = store;
    this.middleware = middleware;
  }

  _createClass(Scheduler, [{
    key: 'start',
    value: function start() {
      var _this2 = this; // Watch for event changes, and dispatches the next event in the chain if it is not cancelled or ended.


      this.disposer = reaction(function () {
        return _this2.event;
      }, function (evt) {
        processEvent(evt, _this2.store).then(function (next) {
          if (next !== null && next.type !== EventTypes.EMPTY) {
            _this2.dispatch(next);
          }
        });
      });
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.disposer && this.disposer();
      this.disposer = null;
    }
  }, {
    key: 'schedule',
    value: function schedule(next) {
      var _this3 = this; // If there is an existing navigation in transition, then cancel it.


      if (this.currentNavigation && this.event.done !== true) {
        this.dispatch({
          type: EventTypes.NAVIGATION_CANCELLED,
          navigation: this.currentNavigation,
          nextNavigation: null,
          done: true
        });
      }

      runInAction(function () {
        _this3.currentNavigation = _this3.currentNavigation.next(next);

        _this3.dispatch({
          type: EventTypes.NAVIGATION_START,
          navigation: _this3.currentNavigation
        });
      });
    }
  }]);

  return Scheduler;
}();

export default Scheduler;